import LocalizedStrings from "react-localization";

export const providerWorkflowMonitoringStrings = new LocalizedStrings({
  en: {
    title: "Provider Workflow Monitoring",
    resetFilters: "Reset filters",
    partitionKey: "PartitionKey",
    rowKey: "RowKey",
    creationDate: "Creation Date",
    lastModificationDate: "Last Modification",
    sourceFile: "Source File",
    status: "Status",
  },
  fr: {
    title: "Suivi du Workflow Fournisseur",
    resetFilters: "Réinitialiser les filtres",
    partitionKey: "PartitionKey",
    rowKey: "RowKey",
    creationDate: "Date de création",
    lastModificationDate: "Dernière modification",
    sourceFile: "Fichier source",
    status: "Statut",
  },
});
